<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'userManagementAddModel',
})
</script>
<template>
  <ant-Modal v-model:open="state.model.visible" :centered="true" :maskClosable="false" :closable="false"
    :title="state.model.title" :width="state.model.width" :confirm-loading="state.loading.submit" :keyboard="false"
    :ok-text="state.model.submitTxt" @ok="onSubmit" @cancel="closeDialog">
    <div class="form-content">
      <a-form ref="formRef" :model="state.ruleForm" :rules="state.rules" :label-col="{ style: 'text-align: right' }"
        :wrapper-col="{ style: 'flex: 1' }">
        <a-form-item label="手机号" name="tel">
          <a-input v-model:value="state.ruleForm.tel" placeholder="请输入手机号" :maxlength="11" allow-clear
            @input="telInput" />
        </a-form-item>
      </a-form>
    </div>
  </ant-Modal>
</template>

<script setup lang="ts" name="userManagementAddModel">
import { reactive, ref, nextTick } from 'vue'
import { cloneDeep } from 'lodash-es'
import { useUser } from '@/store/user'
import { message } from 'ant-design-vue'
import { verifyPhone, verifiyNumberInteger } from '@/utils/toolsValidate'
const userApi = useUser()

const emit = defineEmits(['updatePage'])

const formRef = ref()

const emptyForm = {
  tel: ''
}

const validatePhone = (rule: object, value: string, callback: any) => {
  if (!verifyPhone(value)) {
    return Promise.reject(new Error('输入正确的手机号'))
  } else {
    return Promise.resolve()
  }
}

const state = reactive({
  ruleForm: cloneDeep(emptyForm),
  rules: {
    tel: [{ required: true, validator: validatePhone, trigger: 'blur' }]
  },
  viewType: '',
  model: {
    visible: false,
    title: '',
    submitTxt: '',
    width: '517px'
  },
  loading: {
    submit: false
  }
})

const telInput = () => {
  state.ruleForm.tel = verifiyNumberInteger(state.ruleForm.tel)
}

const openDialog = (type: string, row: any) => {
  state.viewType = type
  state.model.visible = true
  nextTick(() => {
    state.ruleForm = cloneDeep(emptyForm)
    state.model.title = '新增用户'
    state.model.submitTxt = '确认'
  })
}

const closeDialog = () => {
  state.model.visible = false
  state.loading.submit = false
  state.ruleForm = cloneDeep(emptyForm)
  formRef.value?.resetFields()
}

const onSubmit = () => {
  formRef.value
    .validate()
    .then(async () => {
      try {
        state.loading.submit = true
        await userApi.userAdd(state.ruleForm)
        message.success('新增用户成功')
        closeDialog()
        state.loading.submit = false
        emit('updatePage')
      } catch (error) {
        state.loading.submit = false
      }
    })
    .catch(() => {
      state.loading.submit = false
    })
}

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
.form-content {
  padding: 30px 36px 32px 36px;
}

// ===== 表单 =====
:deep(.ant-form-item) {
  margin-bottom: 0px;
  padding-bottom: 24px;
}

:deep(.ant-form-item-label) {
  margin-left: 0px;
  margin-right: 5px;
  width: 60px;
  text-align: right;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  height: 40px;
}

:deep(.ant-form-item-label > label) {
  font-size: 14px;
  line-height: 1;
  font-weight: 400;
}

:deep(.ant-input-affix-wrapper) {
  height: 40px;
  padding: 0 11px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

:deep(.ant-input-disabled) {
  height: 40px;
  border-color: #C5C5D3;
  border-radius: 4px;
}

:deep(.ant-select-selector) {
  height: 40px !important;
  display: flex;
  align-items: center;
  border-radius: 4px;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-input-affix-wrapper:not(:hover):not(.ant-input-affix-wrapper-focused)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-select:not(.ant-select-disabled):not(.ant-select-focused) .ant-select-selector:not(:hover)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(textarea.ant-input:not(:hover):not(:focus)) {
  border-color: #C5C5D3;
}
</style>
